export default {"src":"/_next/static/media/liberty.86d35c08.svg","height":48,"width":48};